import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmt } from "@/api";
import { Check, Package, Truck, Home, RotateCcw } from "lucide-react";

const STEPS = [
  {k:"placed", label:"Order Placed", icon: Check},
  {k:"confirmed", label:"Confirmed", icon: Check},
  {k:"packed", label:"Packed", icon: Package},
  {k:"shipped", label:"Shipped", icon: Truck},
  {k:"out_for_delivery", label:"Out for Delivery", icon: Truck},
  {k:"delivered", label:"Delivered", icon: Home},
];

export default function OrderDetail() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  useEffect(()=>{ api.get(`/orders/${id}`).then(({data})=>setO(data)); }, [id]);
  if (!o) return <div className="p-20 text-center">Loading...</div>;
  const currentIdx = STEPS.findIndex(s => s.k === o.status);

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-700 grid place-items-center mx-auto"><Check className="w-8 h-8"/></div>
        <h1 className="font-serif text-4xl mt-4">Order Confirmed!</h1>
        <p className="text-muted-foreground mt-1">Order #{o.order_no} · Placed on {new Date(o.created_at).toLocaleString()}</p>
      </div>

      <div className="mt-10 rounded-2xl border border-border bg-white p-6">
        <h2 className="font-serif text-xl mb-6">Track Your Order</h2>
        <div className="relative flex justify-between">
          {STEPS.map((s,i)=>(
            <div key={s.k} className="flex-1 flex flex-col items-center relative">
              <div className={`w-10 h-10 rounded-full grid place-items-center z-10 ${i<=currentIdx ? "bg-primary text-white":"bg-muted text-muted-foreground"}`}>
                <s.icon className="w-4 h-4"/>
              </div>
              <div className="text-[10px] mt-2 text-center capitalize">{s.label}</div>
              {i < STEPS.length-1 && <div className={`absolute top-5 left-1/2 right-[-50%] h-0.5 ${i<currentIdx?"bg-primary":"bg-border"}`}/>}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-8 grid md:grid-cols-[1fr_320px] gap-6">
        <div className="rounded-2xl border border-border bg-white p-6">
          <h2 className="font-serif text-xl mb-4">Items ({o.items.length})</h2>
          <div className="space-y-3">
            {o.items.map((it,i)=>(
              <div key={i} className="flex gap-3 items-center">
                <img src={it.image} className="w-14 h-14 rounded-lg object-cover"/>
                <div className="flex-1"><div className="font-medium text-sm">{it.name}</div><div className="text-xs text-muted-foreground">Qty {it.qty} · {fmt(it.price)}</div></div>
                <div className="font-semibold">{fmt(it.price*it.qty)}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          <div className="rounded-2xl border border-border bg-white p-6">
            <h3 className="font-serif text-lg mb-3">Delivery Address</h3>
            <div className="text-sm">
              <div className="font-medium">{o.address.full_name}</div>
              <div className="text-muted-foreground">{o.address.line1}, {o.address.line2}</div>
              <div className="text-muted-foreground">{o.address.city}, {o.address.state} - {o.address.pincode}</div>
              <div className="text-muted-foreground mt-1">📞 {o.address.phone}</div>
            </div>
          </div>
          <div className="rounded-2xl border border-border bg-white p-6">
            <h3 className="font-serif text-lg mb-3">Payment</h3>
            <div className="text-sm space-y-1">
              <div className="flex justify-between"><span>Subtotal</span><span>{fmt(o.subtotal)}</span></div>
              {o.discount>0 && <div className="flex justify-between text-emerald-700"><span>Discount</span><span>-{fmt(o.discount)}</span></div>}
              <div className="flex justify-between"><span>Shipping</span><span>{o.shipping===0?"FREE":fmt(o.shipping)}</span></div>
              <div className="flex justify-between font-semibold pt-2 border-t border-border"><span>Total</span><span className="text-primary">{fmt(o.total)}</span></div>
              <div className="text-xs text-muted-foreground mt-2">Payment: {o.payment_method.toUpperCase()}</div>
            </div>
          </div>
          <Link to="/" className="pk-btn-secondary w-full">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
